<template>
  <v-data-table
    v-bind="dataTableAttrs"
    :headers="headersShown"
    :items="list"
    :loading="isLoading"
    :options.sync="options"
    :server-items-length="total"
    :items-per-page.sync="itemsPerPage"
    v-model="selectedItems"
    @update:items-per-page="handleItemsPerPageUpdated"
    :show-select="false"
  >
    <template v-slot:top>
      <CustomerClusterForm ref="customerClusterForm" @saved="loadList" />
      <rs-table-title-bar
        class="mt-6"
        v-if="$refs.headSearch"
        title=""
        icon=""
        @clear-filters="$refs.headSearch.reset"
        @reload="loadList"
        :search.sync="search.query"
        add-route="#"
        @click:add="handleAddClick"
        hide-edit
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:body.prepend="{ headers }">
      <rs-table-head-search
        :headers="headers"
        :search.sync="search"
        ref="headSearch"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:body.append="{ headers }">
      <rs-table-foot-totals
        :headers="headers"
        :totals="footTotals"
        v-if="list.length > 0"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.edit="{ item }">
      <a
        href="#"
        @click.prevent="handleEditClick(item)"
        class="btn btn-icon btn-sm btn-clean"
      >
        <i class="menu-icon mdi mdi-pencil"></i>
      </a>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.cluster_name="{ item }">
      <router-link
        :to="{
          name: 'definitions.clusters.edit',
          params: {
            id: item.cluster_id,
          },
        }"
      >
        {{ item.cluster_name }}
      </router-link>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.is_active="{ value }">
      <rs-table-cell-boolean :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.cluster_is_active="{ value }">
      <rs-table-cell-boolean :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.starts_on="{ value }">
      <rs-table-cell-date :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.ends_on="{ value }">
      <rs-table-cell-date :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <rs-table-button-delete
        @deleted="handleDeleteClick(item)"
        confirmed
        :loading="isLoading"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <!-- <template v-slot:item.removed_at="{ value, item }">
      <rs-table-cell-date show-time :value="value" v-if="value" />
      <rs-table-button-delete
        v-else
        @deleted="handleDeleteConfirmed(item)"
        :loading="isLoading"
        confirmed
        label="Kaldır"
      />
    </template> -->
  </v-data-table>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";
import { hasDataTable } from "@/view/mixins";
import { mapGetters } from "vuex";
import { CustomerClusterForm } from "../components";

export default {
  name: "AdminCustomerClusterList",
  components: {
    CustomerClusterForm,
  },
  mixins: [hasDataTable],
  props: {
    customerId: {
      type: Number,
      required: false,
    },
  },
  watch: {
    userId() {
      this.loadList();
    },
    search: {
      handler: debounce(function () {
        this.loadList();
      }),
      deep: true,
    },
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["roleList"]),
  },
  data() {
    return {
      options: {
        sortBy: ["cluster_is_active"],
        sortDesc: [true],
      },
      search: {
        is_active: true,
      },
      headers: [
        {
          text: "",
          value: "edit",
          searchable: false,
          sortable: false,
          width: "30px",
          align: "center",
        },
        {
          text: "TYA",
          value: "cluster_name",
          searchable: "text",
        },
        {
          text: "TYA Durumu",
          value: "cluster_is_active",
          searchable: "isActive",
          align: "center",
        },
        {
          text: "Müşteri-TYA Durumu",
          value: "is_active",
          searchable: "isActive",
          align: "center",
        },
        {
          text: "BB",
          value: "house_count",
          searchable: "number",
          align: "center",
          notPrice: true,
        },
        {
          text: "Ekleme",
          value: "starts_on",
          searchable: "date",
        },
        {
          text: "Kaldırma",
          value: "ends_on",
          searchable: "date",
        },
        {
          text: null,
          value: "actions",
          searchable: false,
          sortable: false,
          align: "right",
        },
      ],
    };
  },
  methods: {
    loadList() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.list = [];

      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      if (this.customerId) {
        params.customer_id = this.customerId;
      }

      return this.$api
        .query("api-super-admin/customer-clusters", {
          params,
        })
        .then((response) => {
          this.loadListFromResponse(response);
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    handleAddClick() {
      this.$refs.customerClusterForm.show(this.customerId);
    },
    handleEditClick(item) {
      this.$refs.customerClusterForm.show(this.customerId, item.id);
    },
    handleDeleteClick(item) {
      if (this.isLoading) {
        return false;
      }

      this.isLoading = true;

      return this.$api
        .delete(`api-super-admin/customer-clusters/${item.id}`)
        .then(() => {
          this.$toast.success(this.$t("toasts.item_deleted"));
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
        })
        .then(() => {
          this.loadList();
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadList();
    });
  },
};
</script>
